import { useState } from 'react';
import { MoreHorizontal } from 'lucide-react';

interface QuotedContentToggleProps {
  quotedHtml?: string;
  quotedText?: string;
}

export function QuotedContentToggle({ quotedHtml, quotedText }: QuotedContentToggleProps) {
  const [expanded, setExpanded] = useState(false);

  if (!quotedHtml && !quotedText) return null;

  return (
    <div className="mt-2">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setExpanded(!expanded);
        }}
        className="inline-flex items-center justify-center px-2.5 py-1 rounded-md
                   bg-surface-hover/60 border border-border-strong hover:bg-surface-hover/70 hover:border-accent-primary/40
                   text-text-secondary hover:text-text-primary transition-colors"
        title={expanded ? 'Ukryj cytat' : 'Pokaż cytat'}
      >
        <MoreHorizontal className="w-4 h-4" />
      </button>
      {expanded && (
        <div className="mt-2 pl-3 border-l-2 border-border text-text-secondary">
          {quotedHtml ? (
            <div className="email-body-sandbox text-sm" dangerouslySetInnerHTML={{ __html: quotedHtml }} />
          ) : (
            <pre className="whitespace-pre-wrap text-sm">{quotedText}</pre>
          )}
        </div>
      )}
    </div>
  );
}
